// extracted by mini-css-extract-plugin
export default {"positive":"CurrencyCell_positive__1-vI+","negative":"CurrencyCell_negative__rLCCz"};